import { render, staticRenderFns } from "./media-wx.vue?vue&type=template&id=1aea7620&scoped=true&"
import script from "./media-wx.vue?vue&type=script&lang=js&"
export * from "./media-wx.vue?vue&type=script&lang=js&"
import style0 from "./media-wx.vue?vue&type=style&index=0&id=1aea7620&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aea7620",
  null
  
)

export default component.exports